import {
    ColliScanEventType,
    DeviationState,
    EventType,
    MinimalShipment,
    Shipment,
    ShipmentEventType,
    ShipmentType,
    TemperatureRequirement,
    TemperatureSetting,
} from '@/types/delivery-management'
import { addressString } from '@/utils/string'
import { LocationPoint } from '@/types/company'

export const deviationStates: Record<DeviationState, string> = {
    [DeviationState.Open]: 'open',
    [DeviationState.Closed]: 'closed',
    [DeviationState.Solved]: 'solved',
}

export const shipmentTypes: Record<ShipmentType, string> = {
    [ShipmentType.Delivery]: 'delivery',
    [ShipmentType.Return]: 'return',
    [ShipmentType.Pickup]: 'pickup',
}

export const shipmentEventTypes: Record<ShipmentEventType, string> = {
    [ShipmentEventType.TerminalLoad]: 'loadedOnVehicle',
    [ShipmentEventType.TerminalUnload]: 'unloadedFromVehicle',
    [ShipmentEventType.Delivery]: 'delivered',
    [ShipmentEventType.Pickup]: 'pickedUp',
}

export const colliScanEventTypes: Record<string, string> = {
    [ColliScanEventType.Load]: 'load',
    [ColliScanEventType.Delivery]: 'delivery',
    [ColliScanEventType.Pickup]: 'pickup',
    [ColliScanEventType.Unload]: 'unload',
}

export const tourEventTypes: Record<EventType, string> = {
    [EventType.Shipment]: 'shipment',
    [EventType.Ferry]: 'ferry',
    [EventType.Bridge]: 'bridge',
    [EventType.Waypoint]: 'waypoint',
    [EventType.Decoupling]: 'decoupling',
    [EventType.ShipmentLoad]: 'shipmentLoad',
    [EventType.Coupling]: 'coupling',
}

export const temperatureRequirements: Record<TemperatureRequirement, string> = {
    [TemperatureRequirement.Refrigerated]: 'refrigerated',
    [TemperatureRequirement.Frozen]: 'frozen',
    [TemperatureRequirement.Chilled]: 'chilled',
}

export const temperatureSettings: Record<TemperatureSetting, string> = {
    [TemperatureSetting.Off]: 'off',
    [TemperatureSetting.Constant]: 'constant',
    [TemperatureSetting.OnOff]: 'onOff',
}

export function destinationCompany(shipment: Shipment | MinimalShipment): string {
    if (shipment.type === ShipmentType.Delivery && shipment.packagingOverrideCompany !== null) {
        return shipment.packagingOverrideCompany.name
    }

    if (shipment.type === ShipmentType.Pickup) {
        return shipment.sendingCompany.name
    }

    return shipment.receivingCompany.name
}

export function destinationLocationPoint(shipment: Shipment | MinimalShipment): LocationPoint {
    if (shipment.type === ShipmentType.Delivery && shipment.packagingOverrideLocation !== null) {
        return shipment.packagingOverrideLocation.location
    }

    if (shipment.addressLocation) {
        return shipment.addressLocation
    }

    if (shipment.type === ShipmentType.Pickup) {
        return shipment.sendingCompany.location
    }

    return shipment.receivingCompany.location
}

export function destinationLocationName(shipment: Shipment | MinimalShipment): string {
    if (shipment.type === ShipmentType.Delivery && shipment.packagingOverrideLocation !== null) {
        return shipment.packagingOverrideLocation.name
    }

    if (shipment.addressName) {
        return shipment.addressName
    }

    if (shipment.type === ShipmentType.Pickup) {
        return shipment.sendingCompany.name
    }

    return shipment.receivingCompany.name
}

export function destinationAddress(shipment: Shipment | MinimalShipment): string {
    if (shipment.type === ShipmentType.Delivery && shipment.packagingOverrideLocation !== null) {
        return addressString(shipment.packagingOverrideLocation)
    }

    if (shipment?.address != null) {
        return shipment.address
    }

    if (shipment.type === ShipmentType.Pickup) {
        return addressString(shipment.sendingLocation)
    }

    return addressString(shipment.receivingLocation)
}
